import { ArrowTopRightOnSquareIcon, ArrowUturnLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { DocumentIcon } from "@heroicons/react/24/solid";
import React from "react";

const VisaSecureFaq: React.FC = () => {
  const linkItems = [
    { text: "What is online fraud?", icon: ChevronRightIcon, target: "what-is-online-fraud" },
    { text: "What is payment fraud?", icon: ChevronRightIcon, target: "what-is-payment-fraud" },
    { text: "What is APP fraud and how do I avoid it?", icon: ChevronRightIcon, target: "what-is-app-fraud-and-how-do-i-avoid-it" },
    { text: "What are the most common types of payment fraud?", icon: ChevronRightIcon, target: "what-are-the-most-common-types-of-payment-fraud" },
    { text: "What are the most common types of scams?", icon: ChevronRightIcon, target: "what-are-the-most-common-types-of-scams" },
    { text: "How can I protect myself from fraud?", icon: ChevronRightIcon, target: "how-can-i-protect-myself-from-fraud" },
    { text: "What is contactless card fraud, and how can I prevent it?", icon: ChevronRightIcon, target: "what-is-contactless-card-fraud-and-how-can-i-prevent-it" },
    { text: "What is phishing?", icon: ChevronRightIcon, target: "what-is-phishing" },
    { text: "What is two-Factor Authentication (2FA)?", icon: ChevronRightIcon, target: "what-is-two-factor-authentication-2fa" },
    { text: "What should I do if I suspect fraud on my account?", icon: ChevronRightIcon, target: "what-should-i-do-if-i-suspect-fraud-on-my-account" },
    { text: "What should I do if my card is lost or stolen?", icon: ChevronRightIcon, target: "what-should-i-do-if-my-card-is-lost-or-stolen" },
    { text: "What should I do if I am a victim of fraud or cybercrime?", icon: ChevronRightIcon, target: "what-should-i-do-if-i-am-a-victim-of-fraud-or-cybercrime" },
    { text: "Where can I find more information about fraud prevention?", icon: ChevronRightIcon, target: "where-can-i-find-more-information-about-fraud-prevention" },
  ];

  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <div className="flex items-center flex-wrap gap-4 justify-between">
          <h1 className="text-4xl font-extrabold text-gray-900">Your Online Shopping Secured with Visa</h1>
          <a
            href="/legal/Visa-secure-faq-for-issuers-Orenda.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-blue-600 my-4 gap-1 nc-Button flex-shrink-0 relative h-auto justify-center rounded-full transition-colors border-transparent bg-transparent ring-1 ring-blue-600 hover:bg-transparent hover:text-blue-600 text-sm sm:text-base font-medium py-3 px-4 sm:px-6   "
          >
            <DocumentIcon className="w-4 h-4" />
            Downloadable Version
          </a>
        </div>
        <p className="mt-4 text-lg text-gray-700 font-semibold">Protecting you is our top priority.  </p>
      </header>

      {/* Main Content Section */}
      <section className="w-full px-5 mt-2 p-6">
        <p className="text-gray-800">
          One way we do this is by preventing the unauthorized use of your card. During a purchase from a desktop, mobile or other digital device, you may be guided through an extra check to verify your identity. This helps us ensure you’re you and
          better protects you from fraud.
        </p>
        <p className="text-gray-800">As a Orenda cardholder, your online transactions are secured with Visa. Visa recently enhanced its security for online purchases making the experience more seamless and easy while protecting you from fraud.</p>
      </section>
      <section className="w-full px-5 mt-8 p-6">
        <h2 className="text-2xl font-extrabold text-gray-900">Frequently Asked Questions</h2>

        <div className="mt-6 space-y-8 text-gray-800 leading-relaxed">
          {/* 1 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">How are my online purchases secured with Visa?</h3>
            <p className="mt-2">Visa has developed a programme that helps confirm your identity when you make an online purchase. There’s no need to download anything, install software, or register your account.</p>
            <p className="mt-2">
              During an online purchase from your desktop, mobile, or other digital device, you may be guided through an extra check to verify your identity. This helps us ensure you’re you and better protects you from fraud. This is one way Orenda
              and Visa have teamed up to secure your account(s).
            </p>
          </div>

          {/* 2 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">What is the benefit for consumers?</h3>
            <p className="mt-2">
              Through this programme, you have an added layer of protection that prevents the unauthorised use of your Visa card while shopping online. This service helps us know you’re really you and, most importantly, it protects you from fraud.
            </p>
          </div>

          {/* 3 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">Is my personal information safe and secure?</h3>
            <p className="mt-2">Yes. Your information is transmitted using a high level of encryption and is stored on a secure server.</p>
          </div>

          {/* 4 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">Does this Visa service cost me anything?</h3>
            <p className="mt-2">No. There are no costs associated with this service.</p>
          </div>

          {/* 5 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">How will I know if my online purchase has this added layer of protection?</h3>
            <p className="mt-2">
              This service will automatically work at checkout at any of Visa’s participating online merchants. There’s no need to download anything, install software, or register for an account. When using this service, you may occasionally be
              prompted at checkout to verify your identity—this ensures you’re you and protects you from fraud.
            </p>
            <p className="mt-2">If you see the Visa Secure badge on participating merchants’ websites, this also indicates the use of this service.</p>
          </div>

          {/* 6 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">Can I still use my Orenda card at online merchants that are not participating in this programme?</h3>
            <p className="mt-2">Yes. Your Orenda card will continue to work as usual even if the merchant is not participating. Your transaction will still be protected by multiple layers of security and zero liability for fraudulent purchases.</p>
          </div>

          {/* 7 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">Can I use both credit and debit cards?</h3>
            <p className="mt-2">Yes. This service is designed for both Visa credit and debit cards when shopping online. Using your Visa debit card online will feel similar to using a credit card.</p>
          </div>

          {/* 8 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">What happens when I finish shopping?</h3>
            <p className="mt-2">
              When you are finished shopping, proceed to the merchant’s checkout page. As you complete the transaction, you may be prompted to verify your identity if additional authentication is required. This extra step ensures the person using
              your card is you.
            </p>
          </div>

          {/* 9 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">If I do encounter this extra verification step, what will the extra check be?</h3>
            <p className="mt-2">Orenda may use tools such as a one-time passcode or biometrics to verify your identity. Simply follow the on-screen instructions to complete the authentication.</p>
          </div>

          {/* 10 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">I see the Visa logo when I’m going through the extra check. What’s this about?</h3>
            <p className="mt-2">Visa helps transmit information securely between the merchant and us during this step. The Visa logo is shown to give you peace of mind that the transmission is secure.</p>
          </div>

          {/* 11 */}
          <div>
            <h3 className="text-xl font-bold text-gray-900">Issuer FAQ (Europe)</h3>
            <p className="mt-2">
              The EU’s Second Payment Services Directive (PSD2) mandates Strong Customer Authentication (SCA). Visa’s enhanced security for online purchases—including both e-commerce and m-commerce—meets the SCA requirements of PSD2.
            </p>
            <p className="mt-2">
              Yes, Visa recently enhanced its security for online purchases including both e- commerce and m-commerce transactions that satisfies the Strong Consumer Authentication requirement of the EU’s Payment Services Directive being rolled out
              in 2019
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisaSecureFaq;
